// File: cgp-sidenav.service.ts
// Author: Joseph M Diaz
// Date: 5/10/2017
// Desc: Sidenav component. Items are loaded fromt he config file.
// Other Contributors:

import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable()
export class CgpSidenavService {
    @Output() updatedItemsEvent: EventEmitter<any> = new EventEmitter();

    cgpSidenavComponent;

    // SideNav Actions
    //
    private readonly actions = {};

    constructor() {
        //this is kept empty on purpose
    }

    deselectItems = (items = null) => {
        if (!items) {
            this.deselectItems(this.cgpSidenavComponent.items);
        } else {
            this.cgpSidenavComponent.items = items.map((item) => {
                item.selected = false;
                if (item.children) {
                    this.deselectItems(item.children);
                }
                return item;
            });
        }
    }

    doAction = (item) => {
        this.actions[item.action]();
    }

    setItems = (items) => {
        this.cgpSidenavComponent.items = items;
    }

    getItem = (id) => {
        return JSON.parse(JSON.stringify(this.getOriginalItem(id)));
    }

    getItems = (idList) => {
        return JSON.parse(JSON.stringify(this.getOriginalItems(idList)));
    }

    private readonly getOriginalItem = (id) => {
        const originalItem = this.getOriginalItems([id])[0];

        if (!originalItem) {
            return null;
        }

        return originalItem;
    }

    private readonly getOriginalItems = (idList) => {
        const items = this.flattenItems([], this.cgpSidenavComponent.items);

        return items.filter((n) => {
           return idList.indexOf(n.id) !== -1;
        });
    }

    private readonly flattenItems = (result, items) => {
        for (let i = 0, l = items.length; i < l; i++) {
            const item = items[i];

            result.push(item);

            if (item.children && item.children instanceof Array) {
                this.flattenItems(result, item.children);
            }
        }
        return result;
    }

    updateItem(updatedItem, emitEvents = true) {
        const item = this.getOriginalItem(updatedItem.id);

        for (const p in updatedItem) {
            if (updatedItem.hasOwnProperty(p) && item.hasOwnProperty(p)) {
                item[p] = updatedItem[p];
            }
        }

        if (emitEvents) {
            this.updatedItemsEvent.emit(JSON.parse(JSON.stringify(this.cgpSidenavComponent.items)));
        }
    }

    updateItems(updatedItems) {
        for (let i = 0; i < updatedItems.length; i++) {
            this.updateItem(updatedItems[i], false);
        }

        this.updatedItemsEvent.emit(JSON.parse(JSON.stringify(this.cgpSidenavComponent.items)));
    }
}
